import React from "react";

const EmptyPhysicianListIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="22" fill="#D1E9FF" />
      <path
        d="M22.0002 20.75V23.75M22.0002 23.75V26.75M22.0002 23.75H25.0002M22.0002 23.75H19.0002M12 14L12.0002 30C12.0002 30.5523 12.4479 31 13.0002 31H31.0002C31.5525 31 32.0002 30.5523 32.0002 30L32 17C32 16.4477 31.5523 16 31 16H21.5352C21.2008 16 20.8886 15.8329 20.7031 15.5547L19.2969 13.4453C19.1114 13.1671 18.7992 13 18.4648 13H13C12.4477 13 12 13.4477 12 14Z"
        stroke="#175CD3"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EmptyPhysicianListIcon;
